module.exports = __webpack_public_path__ + "static/media/26.00f958e6.jpg";